import React from 'react';
import { Button } from 'components';
import EntityForm from 'containers/EntityForm/entityForm';
import capitalize from 'helpers/capitailze';
import { API_V4_ENTITIES } from 'constants/entities';
import i18n from '../i18n';
import * as Ui from './renderCell.styles';

const productModalContentStyle = {
  width: 'min(960px, calc(100vw - 32px))',
};

export default (navigate, cell, entity, editable) => {
  if (cell.column.renderCell) {
    return cell.column.renderCell(cell);
  }
  if (
    editable &&
    (cell.column.id === 'name' || (entity === 'child_product' && cell.column.id === 'product_code'))
  ) {
    if (['product', 'theme', 'brand_content', 'location', 'retailer'].includes(entity)) {
      let path = `${entity}/${cell.value}`;
      if (API_V4_ENTITIES.includes(entity)) {
        path = `${entity}/${cell.row.original.uid}`;
      }
      return (
        <Button variant="link" className="p-0" onClick={() => navigate(path)}>
          {cell.render('Cell')}
        </Button>
      );
    }

    const isProductEntity = ['parent_product', 'child_product'].includes(entity);

    return (
      <Ui.Modal
        className="modal-lg"
        contentStyle={isProductEntity ? productModalContentStyle : undefined}
        trigger={
          <Button variant="link" className="p-0">
            {cell.render('Cell')}
          </Button>
        }
        header={{
          title:
            entity === 'category'
              ? i18n.t(`pages:categories.update${capitalize(entity)}`)
              : entity === 'parent_product'
                ? i18n.t(`pages:parentProducts.updateParentProduct`)
                : entity === 'child_product'
                  ? i18n.t(`pages:childProducts.updateChildProduct`)
                  : entity === 'inventory'
                    ? i18n.t(`pages:inventories.updateInventory`)
                    : i18n.t(`pages:${entity}s.update${capitalize(entity)}`),
          subTitle:
            entity === 'category'
              ? i18n.t(`pages:categories.category`)
              : entity === 'parent_product'
                ? i18n.t(`pages:parentProducts.parentProduct`)
                : entity === 'child_product'
                  ? i18n.t(`pages:childProducts.childProduct`)
                  : entity === 'inventory'
                    ? i18n.t(`pages:inventories.inventory`)
                    : i18n.t(`pages:${entity}s.${entity}`),
        }}
      >
        <EntityForm initialValues={cell.row.original} entity={entity} type="update" />
      </Ui.Modal>
    );
  }

  return (
    <p
      style={{ margin: 0 }}
      className={
        ['id', 'dcount', 'views', 'sum', 'productsCount'].includes(cell.column.id) ||
        cell.column.centered
          ? 'text-center'
          : ''
      }
    >
      {cell.render('Cell')}
    </p>
  );
};
